import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentKeyModel, RentalCar } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { DealerOpeningHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-opening-hours-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { AutoKeyBusinessService } from 'projects/Administration/src/app/business-services/auto-key.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { PaymentMasterService } from 'projects/Administration/src/app/business-services/payment-master.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
declare let $: any;
@Component({
  selector: 'app-work-order-appointment-details',
  templateUrl: './work-order-appointment-details.component.html',
  styleUrls: ['./work-order-appointment-details.component.css']
})
export class WorkOrderAppointmentDetailsComponent implements OnInit {
  editcommentform: FormGroup;
  @Input() isWorkOrderHistory: boolean;
  @Output() updatedAppointmentDetails = new EventEmitter<any>();

  internalComment: string;
  internalCommentData: string;
  commentType: number;
  contactDetailsCopiedData: AppointmentDetail;
  closeModel: any;
  selectedRentalCarId: number;
  selectedGenericRentalCarId: number;
  selectedRentalCarDetail: RentalCar;
  isDisableSaveButton: boolean = false;
  isPickupDropoffService: boolean = false;
  PickupHour: number;
  PickupMinutes: number;
  RentalCarValidationCheckBox: boolean =false;
  PickupDatetime: Date;
  commentId: any;
  featureList: Features[] = [];
  popupCloseResult = false;
  @ViewChild("PickupminuteInput") PickupminuteInput: ElementRef;
  DropoffHour: number;
  DropoffMinutes: number;
  DropoffDatetime: Date;
  @ViewChild("DropoffminuteInput") DropoffminuteInput: ElementRef;
  FinishHour: number;
  FinishMinutes: string;
  FinishDatetime: Date;
  @ViewChild("FinishMinuteInput") FinishMinuteInput: ElementRef;
  DeliveryHour: number;
  DeliveryMinutes: string;
  DeliveryDatetime: Date;
  @ViewChild("DeliveryMinuteInput") DeliveryMinuteInput: ElementRef;
  CustomerDropTimeDropDownValues: any = [];
  CustomerPickUpTimeDropDownValues: any = [];
  closeResult: string;
  customerKeyDropInfo: AppointmentKeyModel = null;
  mechanicKeyDropInfo: AppointmentKeyModel = null;
  commentsLenght: number;
  isShareBoxEnabled: boolean = false;
  disableOpenLocker: boolean = false;
  paymentMethodList: any;
  paymentTermsList: any;
  isPickUpDropOff: boolean = false;
  isDsoActive: boolean = false;
  userId: string;
  dealerWorkingHours: DealerOpeningHoursViewModel[];
  DefaultStartTime: string;
  DefaultEndTime: string;
  editCommentText: any;
  editCommentId:any;
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public editAppointmentService: EditAppointmentService,
    public workOrderService: AppointmentWorkOrderService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private userService: UserDataService,
    private secureStorage: SecureStorage,
    private formBuilder: FormBuilder,
    private clipboardApi: ClipboardService,
    private autoKeyService: AutoKeyBusinessService,
    private paymentService: PaymentMasterService,
    public commonService: AppointmentCommonService
  ) { }

  ngOnInit(): void {
    this.editcommentform = this.formBuilder.group({
      comment: ['', [Validators.required]],
    })
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.commonService.isRentalService = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.RenatlCar)?.isActive
        this.commonService.genericRentalCar = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.GRentalCar)?.isActive;
        this.isShareBoxEnabled = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.ShareBox)?.isActive;
        this.isPickUpDropOff = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.PickupDropoff)?.isActive;
        this.isDsoActive = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.DWO)?.isActive;
      }
    }
    if (this.commonService.genericRentalCar) {
      this.commonService.contactDetails.rentalVehicleId = '-1';
      this.selectedGenericRentalCarId = this.commonService.contactDetails?.genericRentalCarTypeId;
    }
    this.contactDetailsCopiedData = JSON.parse(JSON.stringify(this.commonService.contactDetails));
    if (this.commonService.contactDetails?.isRentalCarSelected && this.commonService.isRentalService) {
      this.commonService.contactDetails.isRentalCarSelected = ((this.commonService.contactDetails.rentalVehicleId && this.commonService.contactDetails.rentalVehicleId !== "0") || this.commonService.contactDetails.genericRentalCarTypeId > 0) ? true : false;
    }
    else {
      this.commonService.contactDetails.rentalVehicleId = "0";
      this.commonService.contactDetails.rentalCompanyMakeName = "";
      this.commonService.contactDetails.rentalPrice = "";
      this.commonService.contactDetails.priceForDisply = "";
      this.commonService.contactDetails.price = 0;
      this.commonService.contactDetails.typeId = 0;
      this.commonService.contactDetails.type = "";
    }
    this.commonService.appointmentBookedDate = this.commonService.contactDetails.bookedDateTime ? new Date(this.commonService.contactDetails.bookedDateTime + 'Z') : null;
    this.commonService.appointmentCreatedDate = this.commonService.contactDetails.createdDateTime ? new Date(this.commonService.contactDetails.createdDateTime + 'Z') : null;
    this.commonService.appointmentUpdatedDate = this.commonService.contactDetails.updatedDateTime ? new Date(this.commonService.contactDetails.updatedDateTime + 'Z') : null;
    if (this.commonService.contactDetails?.isPickUpDropOffService) {
      if (this.commonService.contactDetails.pickUpDateTime) {
        this.PickupHour = this.commonService.contactDetails.pickUpDateTime.getHours()
        this.PickupMinutes = this.commonService.contactDetails.pickUpDateTime.getMinutes()
      }
      if (this.commonService.contactDetails.dropOffDateTime) {
        this.DropoffHour = this.commonService.contactDetails.dropOffDateTime.getHours()
        this.DropoffMinutes = this.commonService.contactDetails.dropOffDateTime.getMinutes()
      }
    }

    if (this.commonService.contactDetails.isRentalCarSelected)
      this.onSelectRentalCarCheckBox(true);
    if (this.commonService.appointmentDetails && this.isWorkOrderHistory) {
      this.commonService.getComments(this.commonService.appointmentDetails.appointmentId);
    }
    else {
      this.commonService.getComments(this.editAppointmentService.appointmentDetails.id);
    }
    this.commonService.GetDefaultShift();
    this.getKeyDropInfo();
    this.getPaymentMethod();
    this.getPaymentTerms();
    this.userId = this.userService.currentUserValue.id;
    this.fillCustomerDropDownForPickUpDrop();
  }

  async getPaymentMethod() {
    this.spinner.show();
    await this.paymentService.GetPaymentMethodDropdown().then((response) => {
      this.spinner.hide()
      this.paymentMethodList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }
  async getPaymentTerms() {
    this.spinner.show();
    await this.paymentService.GetPaymentTermDropdown().then((response) => {
      this.spinner.hide()
      this.paymentTermsList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }

  fillCustomerDropDownForPickUpDrop(): void {
    this.CustomerDropTimeDropDownValues = [{
      name: 'lblWithinBusinessHour',
      value: false
    }
      // ,{
      //   name: this.isShareBoxEnabled ? 'lblOutsideOpeningHours-useShareBox' : 'lblOutsideOpeningHours-usekeyDrop',
      //   value: true
      // }
    ];
    this.CustomerPickUpTimeDropDownValues = [{
      name: 'lblWithinBusinessHour',
      value: false
    }
      // ,{
      //   name: this.isShareBoxEnabled ? 'lblOutsideOpeningHours-useShareBox' : 'lblOutsideOpeningHours-usekeyDrop',
      //   value: true
      // }
    ];
    if (this.isShareBoxEnabled) {
      let outsideOpeningHrsOption = {
        name: 'lblOutsideOpeningHours-useShareBox',
        value: true
      }
      this.CustomerDropTimeDropDownValues.push(outsideOpeningHrsOption)
      this.CustomerPickUpTimeDropDownValues.push(outsideOpeningHrsOption)
    }
  }

  emitAppointmentDetail() {
    this.updatedAppointmentDetails.emit({
      updatedAppointmentValues: this.commonService.contactDetails,
      selectedRentalCarDetail: this.selectedRentalCarDetail
    });
  }

  onSelectpickupDropOffServiceCheckBox() {
    if (this.commonService.contactDetails.isPickUpDropOffService) {
      //disable customer waiting false if pickup service selected &  Customer Drop time , Customer Pickup time
      this.commonService.contactDetails.isCustomerWaiting = false;
      this.commonService.contactDetails.isCheckIn = undefined;
      this.commonService.contactDetails.isKeyDrop = undefined;
      this.commonService.contactDetails.isAutoKey = undefined;
    }
    else {
      this.commonService.contactDetails.isCustomerWaiting = this.contactDetailsCopiedData.isCustomerWaiting;
      this.commonService.contactDetails.isCheckIn = this.contactDetailsCopiedData.isCheckIn;
      this.commonService.contactDetails.isKeyDrop = this.contactDetailsCopiedData.isKeyDrop;
      this.commonService.contactDetails.isAutoKey = this.contactDetailsCopiedData.isAutoKey;
      this.PickupHour = this.contactDetailsCopiedData.pickUpDateTime ? this.contactDetailsCopiedData.pickUpDateTime.getHours() : undefined;
      this.PickupMinutes = this.contactDetailsCopiedData.pickUpDateTime ? this.contactDetailsCopiedData.pickUpDateTime.getMinutes() : undefined;
      this.DropoffHour = this.contactDetailsCopiedData.dropOffDateTime ? this.contactDetailsCopiedData.dropOffDateTime.getHours() : undefined;
      this.DropoffMinutes = this.contactDetailsCopiedData.dropOffDateTime ? this.contactDetailsCopiedData.dropOffDateTime.getMinutes() : undefined;
    }
    this.emitAppointmentDetail();
  }


  onCustomerDropTimeSelected(event: any) {
    this.commonService.contactDetails.isKeyDrop = event;
    this.emitAppointmentDetail();
  }

  onCustomerPickUpTimeSelected(event: any) {
    this.commonService.contactDetails.isAutoKey = event;
    this.emitAppointmentDetail();
  }

  onSelectCustomerWaitingCheckBox() {
    if (this.commonService.contactDetails.isCustomerWaiting) {
      //maintain the rental car selection , remove rent car if selected?
      this.commonService.contactDetails.isKeyDrop = undefined;
      this.commonService.contactDetails.isAutoKey = undefined;
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = null;
      this.commonService.contactDetails.rentalCompanyMakeName = null;
      this.commonService.contactDetails.priceForDisply = null;
      this.commonService.contactDetails.price = 0;
      this.selectedRentalCarDetail = null;
      this.workOrderService.isDisableSaveButton = false;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.selectedGenericRentalCarId = null;
    }
    else {
      this.commonService.contactDetails.isKeyDrop = this.contactDetailsCopiedData.isKeyDrop;
      this.commonService.contactDetails.isAutoKey = this.contactDetailsCopiedData.isAutoKey;
    }
    this.emitAppointmentDetail();
  }
 
  onSelectRentalCarCheckBox(value: boolean) { 
    if(!this.commonService.contactDetails.isRentalCarSelected){
      this.RentalCarValidationCheckBox = false;
    }
    if(!this.RentalCarValidationCheckBox && this.commonService.contactDetails.isRentalCarSelected){
      this.workOrderService.isDisableSaveButton = true; 
      this.commonService.contactDetails.rentalPrice = '';
      this.commonService.contactDetails.rentalVehicleId='0';
      this.commonService.contactDetails.typeId = 0;
    }
    if(!this.RentalCarValidationCheckBox && !this.commonService.contactDetails.isRentalCarSelected){
      this.workOrderService.isDisableSaveButton = false; 
    }
    if (!this.commonService.contactDetails.isRentalCarSelected && value) {
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = this.contactDetailsCopiedData.rentalVehicleId;
      this.commonService.contactDetails.rentalCompanyMakeName = this.contactDetailsCopiedData.rentalCompanyMakeName;
      this.commonService.contactDetails.price = this.contactDetailsCopiedData.price;
      this.selectedRentalCarDetail = null;
      this.workOrderService.isDisableSaveButton = false;
    }
    if (!this.commonService.contactDetails.isRentalCarSelected && !value) {
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = null;
      this.commonService.contactDetails.rentalCompanyMakeName = null;
      this.commonService.contactDetails.priceForDisply = null;
      this.commonService.contactDetails.price = 0;
      this.selectedRentalCarDetail = null;
      this.workOrderService.isDisableSaveButton = false;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.selectedGenericRentalCarId = null;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && !this.commonService.genericRentalCar && !this.contactDetailsCopiedData.rentalVehicleId) {
      this.workOrderService.isDisableSaveButton = true;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar && !this.commonService.contactDetails.rentalCompanyMakeName) {
      this.workOrderService.isDisableSaveButton = true;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar) {
      this.onRentalCarSelected();
    }
  }

  onRentalCarSelected() {
    if (this.selectedRentalCarId && !this.commonService.genericRentalCar) {
      this.workOrderService.isRentalCarUpdated = true;
      this.RentalCarValidationCheckBox = true;
      this.selectedRentalCarDetail = this.commonService.availRentalCarList.filter(x => x.vehicleId === this.selectedRentalCarId)[0];
      this.commonService.contactDetails.rentalVehicleId = this.selectedRentalCarDetail.vehicleId.toString();
      this.commonService.contactDetails.rentalCompanyMakeName = this.selectedRentalCarDetail.makeName;
      this.commonService.contactDetails.price = this.selectedRentalCarDetail.price;
      this.commonService.contactDetails.priceForDisply = this.selectedRentalCarDetail.price;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.contactDetails.rentalVehicleId && !this.commonService.genericRentalCar) {
      this.workOrderService.isDisableSaveButton = false;
    }
    if (this.selectedGenericRentalCarId && this.commonService.genericRentalCar) {
      let details: RentalCar = {
        vehicleId: 0,
        makeName: '',
        model: '',
        licensePlate: '',
        price: 0
      }
      this.selectedRentalCarDetail = details;
      this.commonService.contactDetails.isGenericRentalCar = this.commonService.genericRentalCar;
      this.workOrderService.isRentalCarUpdated = true;
      let model = this.commonService.genericRentalCarList.filter(x => x.typeId === this.selectedGenericRentalCarId)[0];
      if (model == undefined) {
        this.selectedRentalCarDetail.makeName = this.commonService.contactDetails.rentalCompanyMakeName;//rentalCompanyMakeName
        this.selectedRentalCarDetail.model = this.commonService.contactDetails.priceForDisply;//priceForDisply
      }
      else {
        this.selectedRentalCarDetail.makeName = model.type;//rentalCompanyMakeName
        this.selectedRentalCarDetail.model = model.price;//priceForDisply
        this.commonService.contactDetails.rentalCompanyMakeName = model.type;//rentalCompanyMakeName
        this.commonService.contactDetails.genericRentalCarTypeId = model.typeId; //genericRentalCarTypeId
        this.commonService.contactDetails.priceForDisply = model.price; //priceForDisply
      }
      this.commonService.contactDetails.rentalVehicleId = "0";
      this.commonService.contactDetails.price = 0;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar) {
      this.workOrderService.isDisableSaveButton = false;
    }
    this.emitAppointmentDetail();
  }


  MoveToDurationMinute(e, flag: string, isShowToaster: boolean) {
    this.MoveToMinute(e, flag, true, isShowToaster);
  }

  MoveToMinute(e, flag, isShowToaster: boolean, isToDuration = false) {
    if ((flag === "DeliveryTime" && this.DeliveryHour > 23) || (flag === "FinishTime" && this.FinishHour > 23)) {
      let errorMsg = this.translate.instant("lblHoursShouldBeLessThan23");
      if (isShowToaster) {
        this.toastr.error(errorMsg);
      }
      this.workOrderService.isDisableSaveButton = true;
      return;
    }
    else {
      this.workOrderService.isDisableSaveButton = false;
    }
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        let minInput;
        if (isToDuration) {
          if (flag === "Pickup")
            minInput = this.PickupminuteInput.nativeElement;
          if (flag === "Dropoff")
            minInput = this.DropoffminuteInput.nativeElement;
          if (flag === "FinishTime")
            minInput = this.FinishMinuteInput.nativeElement;
          if (flag === "DeliveryTime")
            minInput = this.DeliveryMinuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
    this.FinishDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.FinishHour, this.FinishMinutes)
    this.DeliveryDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.DeliveryHour, this.DeliveryMinutes)
    this.commonService.contactDetails.finishedTime = this.FinishDatetime;
    this.commonService.contactDetails.deliveryTime = this.DeliveryDatetime;
    this.emitAppointmentDetail();
  }

  CheckMinute(_e, flag: string, isShowToaster: boolean) {
    if (flag === "Pickup" && this.PickupMinutes >= 60) {
      let errorMsg = this.translate.instant("lblMinuteShouldBeLessThan60");
      if (isShowToaster) {
        this.toastr.error(errorMsg);
      }
      this.workOrderService.isDisableSaveButton = true;
      return;
    }
    if (flag === "Dropoff" && this.DropoffMinutes >= 60) {
      let errorMsg = this.translate.instant("lblMinuteShouldBeLessThan60");
      if (isShowToaster) {
        this.toastr.error(errorMsg);
      }
      this.workOrderService.isDisableSaveButton = true;
      return;
    }
    if (flag === "FinishTime" && this.FinishMinutes >= "60") {
      let errorMsg = this.translate.instant("lblMinuteShouldBeLessThan60");
      if (isShowToaster) {
        this.toastr.error(errorMsg);
      }
      this.workOrderService.isDisableSaveButton = true;
      return;
    }
    if (flag === "DeliveryTime" && this.DeliveryMinutes >= "60") {
      let errorMsg = this.translate.instant("lblMinuteShouldBeLessThan60");
      if (isShowToaster) {
        this.toastr.error(errorMsg);
      }
      this.workOrderService.isDisableSaveButton = true;
      return;
    }
    if (this.DeliveryMinutes == null || this.FinishMinutes == null) {
      this.workOrderService.isDisableSaveButton = false;
    }
    let hourErrorMsg = this.translate.instant("lblEnterHours");
    switch (flag) {
      case "Pickup":
        if (isNullOrUndefined(this.PickupHour)) {
          if (isShowToaster) {
            this.toastr.error(hourErrorMsg);
          }
          this.workOrderService.isDisableSaveButton = true;
          return;
        }
        this.PickupDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.PickupHour, this.PickupMinutes)
        this.commonService.contactDetails.pickUpDateTime = this.PickupDatetime;
        break;
      case "Dropoff":
        if (isNullOrUndefined(this.DropoffHour)) {
          if (isShowToaster) {
            this.toastr.error(hourErrorMsg);
          }
          this.workOrderService.isDisableSaveButton = true;
          return;
        }
        this.DropoffDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.DropoffHour, this.DropoffMinutes)
        this.commonService.contactDetails.dropOffDateTime = this.DropoffDatetime;
        break;
      case "FinishTime":
        if (isNullOrUndefined(this.FinishHour)) {
          if (isShowToaster) {
            this.toastr.error(hourErrorMsg);
          }
          this.workOrderService.isDisableSaveButton = true;
          return;
        }
        this.FinishDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.FinishHour, this.FinishMinutes)
        this.commonService.contactDetails.finishedTime = this.FinishDatetime;
        break;
      case "DeliveryTime":
        if (isNullOrUndefined(this.DeliveryHour)) {
          if (isShowToaster) {
            this.toastr.error(hourErrorMsg);
          }
          this.workOrderService.isDisableSaveButton = true;
          return;
        }
        this.DeliveryDatetime = this.calculateDateTime(this.commonService.appointmentBookedDate, this.DeliveryHour, this.DeliveryMinutes)
        this.commonService.contactDetails.deliveryTime = this.DeliveryDatetime;
        break;
      default:
        break;
    }
    this.workOrderService.isDisableSaveButton = false;
    this.emitAppointmentDetail();
  }

  calculateDateTime(selectedDate, Hour, Minute): Date {
    let minute = isNullOrUndefined(Minute) ? 0 : Minute;
    let month = selectedDate.getUTCMonth() + 1; //months from 1-12
    let date = selectedDate.getUTCDate();
    let year = selectedDate.getUTCFullYear();

    return new Date(year, month - 1, date, +Hour, +minute);
  }
  onChangeDeliveryDate(event:any){

    this.commonService.contactDetails.deliveryTime = Utility.getDateStringToDate(event);
    this.commonService.contactDetails.deliveryTime?.setHours(this.commonService.deliveryTimeSlot.hour);
    this.commonService.contactDetails.deliveryTime?.setMinutes(this.commonService.deliveryTimeSlot.minute);
    this.emitAppointmentDetail();
  }
  onChangeDeliveryTime(time: any): void {
    this.commonService.contactDetails.deliveryTime?.setHours(time?.hour ?? 0);
    this.commonService.contactDetails.deliveryTime?.setMinutes(time?.minute ?? 0);
    this.emitAppointmentDetail();
  }
  onChangeFinnishedDate(event:any){
    this.commonService.contactDetails.finishedTime = Utility.getDateStringToDate(event);
    this.commonService.contactDetails.finishedTime?.setHours(this.commonService.finishTimeSlot.hour);
    this.commonService.contactDetails.finishedTime?.setMinutes(this.commonService.finishTimeSlot.minute);
    this.emitAppointmentDetail();
  }
  onChangeFinnishedTime(time: any): void {
    this.commonService.contactDetails.finishedTime?.setHours(time?.hour ?? 0);
    this.commonService.contactDetails.finishedTime?.setMinutes(time?.minute ?? 0);
    this.emitAppointmentDetail();
  }
  OpenRentalCarListPopup(Content) {
    this.spinner.show();
    this.selectedRentalCarId = null;
    this.commonService.getRentalCar();
    this.modalService.open(Content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }

  open(Internalcontent) {
    this.internalCommentData = null
    this.modalService.open(Internalcontent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }
  copyInternalComments() {
    this.clipboardApi.copyFromContent(this.commonService.internalComment)
  }
  AddInternalComment() {
    if(this.commonService.internalCommentData.trim()){
      this.commonService.AddInternalComment();
      this.commonService.internalCommentData = null;
    }
    else{
      let noSpaceAllowedInComment = this.translate.instant("lblOnlySpaceNotAllowed");
      this.toastr.error(noSpaceAllowedInComment);
    }
  }
  
  ViewComment(viewContent, commentType) {
    this.commentType = commentType
    this.commonService.CommentsByCount(this.commentType);
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }
  EditComment(editcontent, comment) {
    this.editCommentText = comment.comment;
    this.editCommentId = comment.id;
    this.closeModel = this.modalService.open(editcontent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }

  getKeyDropInfo(): void {
    if (this.isShareBoxEnabled) {
      let keyList = this.commonService.contactDetails.appointmentKeyList;
      if (keyList && keyList.length > 0) {
        keyList.forEach(item => {
          if (item.exchangeMethod == 0) {
            item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate + "Z")) : null;
            item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate + "Z")) : null;
            this.customerKeyDropInfo = item;
          }
          else if (item.exchangeMethod == 1) {
            item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate + "Z")) : null;
            item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate + "Z")) : null;
            this.mechanicKeyDropInfo = item;
          }
        });
      }
    }
  }

  openLocker(autoKeyId: number) {

    this.spinner.show();
    this.disableOpenLocker = false;
    this.autoKeyService.openLocker(autoKeyId, Application.Admin).then(res => {
      if (res) {
        if (res.responseObject === true) {
          let success = this.translate.instant("lblLockerIsOpened");
          this.toastr.success(success);
          this.disableOpenLocker = true;
          this.ngOnInit();
        }
        else if (res.responseObject === false) {
          let error = this.translate.instant("lblLockerOpenFailed");
          this.toastr.error(error);
        }
        else if (res.responseObject.errorCount > 0) {
          this.spinner.hide();
        }
      }
    })
    this.spinner.hide();
  }
  IsNumeric(event: any) {
    const keyCode = (event.which) ? event.which : event.keyCode;
    // Allow: backspace, delete, tab, escape, and enter (do not allow dot)
    //// Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(keyCode, [8, 9, 27, 13, 190, 44, 45, 46]) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (keyCode == 65 && (event.ctrlKey === true || event.metaKey === true))) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (event.shiftKey || ((keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105))) {
      event.preventDefault();
    }
  }

  DeleteComment(Comments: any) {
    this.commonService.DeleteComment(Comments);
  }

  EditCommentDetails() {
    this.commonService.EditCommentDetails(this.editCommentText,this.editCommentId);
    this.closeModel.close();
  }

  onSelectToweinCarCheckBox(event) {
    this.commonService.contactDetails.toweinCars = event;
  }
}
